import axios from "axios";
import {
  ALL_GUEST_COMMENT_RECENT_FAIL,
  ALL_GUEST_COMMENT_RECENT_REQUEST,
  ALL_GUEST_COMMENT_RECENT_SUCCESS,
  GUEST_COMMENT_PAST_FAIL,
  GUEST_COMMENT_PAST_REQUEST,
  GUEST_COMMENT_PAST_SUCCESS,
  GUEST_COMMENT_TODAY_FAIL,
  GUEST_COMMENT_TODAY_REQUEST,
  GUEST_COMMENT_TODAY_SUCCESS,
  GUEST_USER_COMMENT_INSERT_FAIL,
  GUEST_USER_COMMENT_INSERT_REQUEST,
  GUEST_USER_COMMENT_INSERT_SUCCESS,
  GUEST_USER_DETAIL_FAIL,
  GUEST_USER_DETAIL_REQUEST,
  GUEST_USER_DETAIL_RESET,
  GUEST_USER_DETAIL_SUCCESS,
  GUEST_USER_LOGIN_FAIL,
  GUEST_USER_LOGIN_REQUEST,
  GUEST_USER_LOGIN_RESET,
  GUEST_USER_LOGIN_SUCCESS,
} from "../constants/userConstants";
import api from "../core/api";
let Api = process.env.REACT_APP_SEARCH_API_URL2;

export const loginGuestUser = (userdt) => async (dispatch) => {
  try {
    dispatch({ type: GUEST_USER_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.post(`/guest/login`, userdt, config);
    // console.log(data);
    const dt = data;
    if (dt?.Result.includes("Error")) {
      dispatch({
        type: GUEST_USER_LOGIN_FAIL,
        payload: dt?.Result?.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: GUEST_USER_LOGIN_SUCCESS,
        payload: dt.accesstoken,
      });

      const dt3 = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString();
      const dt1 = dt3.split("T")[0] + " 00:00:00";
      localStorage.setItem("expdt", dt1);
      localStorage.setItem("guestInfo", dt.accesstoken);
    }

    // dispatch({
    //     type: GUEST_USER_LOGIN_SUCCESS,
    //     payload: dt
    // })
  } catch (error) {
    dispatch({
      type: GUEST_USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const loginCrmGuestUser = (userdt) => async (dispatch) => {
  try {
    dispatch({ type: GUEST_USER_LOGIN_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await axios.post(`${Api}/users/login`, userdt, config);

    const dt = data;
    if (dt?.Result.includes("Error")) {
      dispatch({
        type: GUEST_USER_LOGIN_FAIL,
        payload: dt?.Result?.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: GUEST_USER_LOGIN_SUCCESS,
        payload: dt.accesstoken,
      });
      // console.log(dt?.Result[0]);
      const dt3 = new Date(Date.now() + 2 * 24 * 60 * 60 * 1000).toISOString();
      const dt1 = dt3.split("T")[0] + " 00:00:00";
      localStorage.setItem("guestCrm", JSON.stringify(dt?.Result[0]));
      localStorage.setItem("expdt", dt1);
      localStorage.setItem("guestInfo", dt.accesstoken);
    }

    // dispatch({
    //     type: GUEST_USER_LOGIN_SUCCESS,
    //     payload: dt
    // })
  } catch (error) {
    dispatch({
      type: GUEST_USER_LOGIN_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const detailsGuestUser = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GUEST_USER_DETAIL_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    const {
      guestUserLogin: { userInfo },
    } = getState();

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.get(`/guest/getGuestDetails`, config);

      const dt = data;
      if (typeof dt == "string") {
        dispatch({
          type: GUEST_USER_DETAIL_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: GUEST_USER_DETAIL_SUCCESS,
          payload: dt.Result,
        });
      }
    } else {
      dispatch({
        type: GUEST_USER_DETAIL_FAIL,
        payload: "Please Login",
      });
    }
  } catch (error) {
    dispatch({
      type: GUEST_USER_DETAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const detailsCrmUser = () => async (dispatch, getState) => {
  try {
    dispatch({ type: GUEST_USER_DETAIL_REQUEST });

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    const {
      guestUserLogin: { userInfo },
    } = getState();

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await axios.get(`${Api}/users/GetUsers`, config);
      // console.log(data);
      const dt = data;
      if (typeof dt == "string") {
        dispatch({
          type: GUEST_USER_DETAIL_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: GUEST_USER_DETAIL_SUCCESS,
          payload: dt.Result,
        });
      }
    } else {
      dispatch({
        type: GUEST_USER_DETAIL_FAIL,
        payload: "Please Login",
      });
    }
  } catch (error) {
    dispatch({
      type: GUEST_USER_DETAIL_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const insertGuestUser = (parm) => async (dispatch, getState) => {
  try {
    dispatch({ type: GUEST_USER_COMMENT_INSERT_REQUEST });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + userInfo,
      },
    };
    // console.log(config);
    // console.log(parm);

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.post(`/guest/InsertComment`, parm, config);

      const dt = data.Result;
      if (dt.includes("Error")) {
        dispatch({
          type: GUEST_USER_COMMENT_INSERT_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: GUEST_USER_COMMENT_INSERT_SUCCESS,
          payload: dt,
        });
      }
    } else {
      dispatch({
        type: GUEST_USER_COMMENT_INSERT_FAIL,
        payload: "User Not Logged In!",
      });
    }
  } catch (error) {
    // console.log(error);
    dispatch({
      type: GUEST_USER_COMMENT_INSERT_FAIL,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const insertGuestCrmUser = (parm) => async (dispatch, getState) => {
  try {
    dispatch({ type: GUEST_USER_COMMENT_INSERT_REQUEST });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + userInfo,
      },
    };
    // console.log(config);
    // console.log(parm);

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.post(
        `${Api}/guest/InsertComment/Crmuser`,
        parm,
        config
      );

      const dt = data.Result;
      if (dt.includes("Error")) {
        dispatch({
          type: GUEST_USER_COMMENT_INSERT_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: GUEST_USER_COMMENT_INSERT_SUCCESS,
          payload: dt,
        });
      }
    } else {
      dispatch({
        type: GUEST_USER_COMMENT_INSERT_FAIL,
        payload: "User Not Logged In!",
      });
    }
  } catch (error) {
    // console.log(error);
    dispatch({
      type: GUEST_USER_COMMENT_INSERT_FAIL,
      payload:
        error.response && error.response.data.Result
          ? error.response.data.Result
          : error.message,
    });
  }
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("guestInfo");
  localStorage.removeItem("expdt");
  localStorage.removeItem("guestCrm");
  localStorage.clear();
  dispatch({ type: GUEST_USER_DETAIL_RESET });
  dispatch({ type: GUEST_USER_LOGIN_RESET });
};

export const getTodayComments =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GUEST_COMMENT_TODAY_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await api.post(
          `/guest/GuestCommentsFilters`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: GUEST_COMMENT_TODAY_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: GUEST_COMMENT_TODAY_SUCCESS,
            payload: dt,
          });
        }
      } else {
        dispatch({
          type: GUEST_COMMENT_TODAY_FAIL,
          payload: "User not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: GUEST_COMMENT_TODAY_FAIL,
        payload: message,
      });
    }
  };

export const getSelfPastComments =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GUEST_COMMENT_PAST_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await api.post(
          `/guest/GuestCommentsFilters`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: GUEST_COMMENT_PAST_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: GUEST_COMMENT_PAST_SUCCESS,
            payload: dt,
          });
        }
      } else {
        dispatch({
          type: GUEST_COMMENT_PAST_SUCCESS,
          payload: "User Not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: GUEST_COMMENT_PAST_FAIL,
        payload: message,
      });
    }
  };

export const getRecentCommentsByAll = (parm) => async (dispatch, getState) => {
  try {
    dispatch({
      type: ALL_GUEST_COMMENT_RECENT_REQUEST,
    });

    const {
      guestUserLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        authorization: "Bearer " + localStorage.getItem("guestInfo"),
      },
    };

    if (userInfo != undefined || userInfo != "" || userInfo != null) {
      const { data } = await api.post(
        `/guest/GuestCommentsFilters`,
        parm,
        config
      );

      var dt = data.Result;
      //console.log(data)
      if (typeof dt == "string") {
        dispatch({
          type: ALL_GUEST_COMMENT_RECENT_FAIL,
          payload: dt.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: ALL_GUEST_COMMENT_RECENT_SUCCESS,
          payload: dt,
        });
      }
    } else {
      dispatch({
        type: ALL_GUEST_COMMENT_RECENT_FAIL,
        payload: "User not logged In!",
      });
    }
  } catch (error) {
    const message =
      error.response && error.response.data.message
        ? error.response.data.message
        : error.message;
    dispatch({
      type: ALL_GUEST_COMMENT_RECENT_FAIL,
      payload: message,
    });
  }
};

// for Crm user

export const getTodayCrmUserComments =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GUEST_COMMENT_TODAY_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await axios.post(
          `${Api}/guest/GuestCommentsFilters/crmuser`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: GUEST_COMMENT_TODAY_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: GUEST_COMMENT_TODAY_SUCCESS,
            payload: dt,
          });
        }
      } else {
        dispatch({
          type: GUEST_COMMENT_TODAY_FAIL,
          payload: "User not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: GUEST_COMMENT_TODAY_FAIL,
        payload: message,
      });
    }
  };

export const getSelfCrmUserPastComments =
  (activityData) => async (dispatch, getState) => {
    try {
      dispatch({
        type: GUEST_COMMENT_PAST_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await axios.post(
          `${Api}/guest/GuestCommentsFilters/crmuser`,
          activityData,
          config
        );

        var dt = data.Result;
        if (typeof dt == "string") {
          dispatch({
            type: GUEST_COMMENT_PAST_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: GUEST_COMMENT_PAST_SUCCESS,
            payload: dt,
          });
        }
      } else {
        dispatch({
          type: GUEST_COMMENT_PAST_SUCCESS,
          payload: "User Not Logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: GUEST_COMMENT_PAST_FAIL,
        payload: message,
      });
    }
  };

export const getRecentCrmUserCommentsByAll =
  (parm) => async (dispatch, getState) => {
    try {
      dispatch({
        type: ALL_GUEST_COMMENT_RECENT_REQUEST,
      });

      const {
        guestUserLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + localStorage.getItem("guestInfo"),
        },
      };

      if (userInfo != undefined || userInfo != "" || userInfo != null) {
        const { data } = await axios.post(
          `${Api}/guest/GuestCommentsFilters/crmuser`,
          parm,
          config
        );

        var dt = data.Result;
        //console.log(data)
        if (typeof dt == "string") {
          dispatch({
            type: ALL_GUEST_COMMENT_RECENT_FAIL,
            payload: dt.replace("Error - ", ""),
          });
        } else {
          dispatch({
            type: ALL_GUEST_COMMENT_RECENT_SUCCESS,
            payload: dt,
          });
        }
      } else {
        dispatch({
          type: ALL_GUEST_COMMENT_RECENT_FAIL,
          payload: "User not logged In!",
        });
      }
    } catch (error) {
      const message =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      dispatch({
        type: ALL_GUEST_COMMENT_RECENT_FAIL,
        payload: message,
      });
    }
  };
